import React from 'react';
import { Link } from 'react-router-dom';
import {
	Breadcrumb,
	BreadcrumbHome,
	BreadcrumbItem,
	Module,
	ModuleBody,
	SecondaryNavigation,
	SecondaryNavigationTitle,
	Wrapper,
} from '@wfp/ui';

import { lastHomepageUrl } from '../../utils/navigation';
import { usePreviewMonth, usePreviewTypeIsDoc } from '../../hooks/preview';
import { formatDateShort } from '../../utils/utils';
import { DataLoaderPreview } from './DataLoaderPreview';

import './PagePreview.scss';


export function PagePreview() {
	const month = usePreviewMonth();
	const isDoc = usePreviewTypeIsDoc();
	const pageTitle = isDoc ? 'Monthly Report' : 'Active Warnings';

	return (<div key={month}>
		<SecondaryNavigation>
			<Breadcrumb>
				<BreadcrumbItem>
					<Link to="/"><BreadcrumbHome/></Link>
				</BreadcrumbItem>
				<BreadcrumbItem>
					<Link to={lastHomepageUrl}>Homepage</Link>
				</BreadcrumbItem>
				<BreadcrumbItem disableLink>{pageTitle}</BreadcrumbItem>
			</Breadcrumb>
			<SecondaryNavigationTitle>Preview</SecondaryNavigationTitle>
		</SecondaryNavigation>

		<Wrapper className="main-wrapper" background="lighter" pageWidth={isDoc ? 'lg' : 'full'} spacing="md">
			<Module>
				<ModuleBody>
					<div className="preview">
						<h1>WFP EARLY WARNING WATCH LIST{isDoc ? '' : ': ACTIVE WARNINGS'}</h1>
						<h2 className="mb1 not-bold">{formatDateShort(month)}</h2>
						<DataLoaderPreview/>
					</div>
				</ModuleBody>
			</Module>
		</Wrapper>
	</div>);
}
